module.exports = __webpack_public_path__ + "img/trophy.3a22f6af.svg";